import { ChangeDetectionStrategy, Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { BACKLOG_INITIATIVE_LABELS, BREAK_IN_OUT_LABELS, CAPEX_CUTLINE_LABELS, CAPEX_PRIORITIZATION_LABELS, FORECAST_LABELS, MEJ_CUTLINE_LABELS, PLAN_VS_FACT_LABELS, REPORT_AND_EWR_LABELS } from './column-labels.constant';

@Component({
  selector: 'app-display-columns-dialog',
  standalone: false,
  templateUrl: './display-columns-dialog.component.html',
  styleUrls: ['./display-columns-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DisplayColumnsDialogComponent implements OnInit {
  allColumns: string[] = [];
  selectedColumns: string[] = [];
  currentSelectedColumns: string[] = [];
  component: string = '';
  private columnLabels: { [key: string]: string } = {};


  constructor(
    private dialogRef: MatDialogRef<DisplayColumnsDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.allColumns = data.allColumns || [];
    this.selectedColumns = data.selectedColumns || [];
    this.component = data.component || '';
  }



  ngOnInit(): void {
    if (this.component === 'MEJ_CUTLINE') {
      this.columnLabels = MEJ_CUTLINE_LABELS;
    } else if (this.component === 'CAPEX_CUTLINE') {
      this.columnLabels = CAPEX_CUTLINE_LABELS;
    } else if (this.component === 'BACKLOG_INITIATIVE') {
      this.columnLabels = BACKLOG_INITIATIVE_LABELS;
    } else if (this.component === 'BREAK_IN_OUT') {
      this.columnLabels = BREAK_IN_OUT_LABELS;
    } else if (this.component === 'REPORT_AND_EWR') {
      this.columnLabels = REPORT_AND_EWR_LABELS;
    } else if (this.component === 'FORECAST') {
      this.columnLabels = FORECAST_LABELS;
    } else if (this.component === 'PLAN_VS_FACT') {
      this.columnLabels = PLAN_VS_FACT_LABELS;
    }
    else if (this.component === 'CAPEX_PRIORITIZATION') {
      this.columnLabels = CAPEX_PRIORITIZATION_LABELS;
    } else {
      this.columnLabels = {}; // Default to an empty object if no match
    }
    this.currentSelectedColumns = [...this.selectedColumns];
  }

  getColumnLabel(column: string): string {
    return this.columnLabels[column] || column;
  }

  isColumnSelected(column: string): boolean {
    return this.currentSelectedColumns.includes(column);
  }

  toggleColumn(column: string): void {
    if (this.currentSelectedColumns.includes(column)) {
      this.currentSelectedColumns = this.currentSelectedColumns.filter(c => c !== column);
    } else {
      this.currentSelectedColumns.push(column);
    }
  }

  onSave(): void {
    this.dialogRef.close({
      currentSelectedColumns: this.currentSelectedColumns
    });
  }

  onCancel(): void {
    this.dialogRef.close();
  }

  get allSelected(): boolean {
    return this.currentSelectedColumns.length === this.allColumns.length;
  }

  selectAll(): void {
    this.currentSelectedColumns = [...this.allColumns];
  }

  deselectAll(): void {
    this.currentSelectedColumns = [];
  }
}
